import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { HomeContact, arrow3, arrow } from "../../constant";
import {
  bookMemberShipPost,
  GetMembership,
  GetMembershipLocation,
  PostMembershipById,
} from "../../network/Network";
import ActionButton from "../ActionBtn/ActionButton";
import StripeForm from "../PaymentMethod/StripeForm";

function HomeContactForm() {
  const ref = useRef();
  const new_date = new Date().toISOString().slice(0, 10);
  const setref = useRef();
  const [farmerMembership, setFarmerMembership] = useState([]);
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const [campingMembership, setCampingMembership] = useState([]);
  const Token = useSelector((state) => state?.AuthReducer?.token);
  const [locationMemb, setLocationMemb] = useState(null);
  const [locationVal, setLocatinVal] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [gardenMembership, setGardenMembership] = useState([]);
  const [camping, setCamping] = useState();
  const [state, setState] = useState({
    membership_id: 9,
    is_family_membership: "",
    // other_memberships_included: "",
    price: gardenMembership?.price,
    booking_date: "",
    booking_time: "",
  });
  const [loading, setLoading] = useState(false);
  const [singleCamping, setSingleCamping] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Get Membership by id
  useEffect(() => {
    setLoading(true);
    PostMembershipById(9)
      .then((res) => {
        setLoading(false);
        setFarmerMembership(res?.data);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    GetMembership()
      .then((res) => {
        setLoading(false);
        setCamping(res.data);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    GetMembershipLocation()
      .then((res) => {
        setLoading(false);
        setLocationMemb(res?.data?.response?.data);
        setLocatinVal(res.data.response.data[0].id);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const setFarmMemberFunc = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const PlaceOrderHandler = (e, stripe_token) => {
    e.preventDefault();
    if (!state?.booking_date || !state?.booking_time || !locationVal) {
      toast.error("Plese fill all compulsory fields");
    } else {
      setLoading(true);
      let sendData = {
        membership_id: state?.membership_id,
        // is_family_membership: state?.is_family_membership,
        // other_memberships_included: state?.other_memberships_included ? singleCamping?.id : null,
        price: farmerMembership?.price,
        _token: stripe_token,
        booking_date: state?.booking_date,
        booking_time: state?.booking_time,
        farm_location_id: locationVal,
        type: "booking",
      };
      bookMemberShipPost(sendData, Token)
        .then((res) => {
          setLoading(false);
          navigate("/");
          toast.success(
            "Farmer’s Booth Space booking has been done successfully"
          );
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        })
        .catch((err) => {
          toast.error(`${err?.response?.data?.message}`);
          setLoading(false);
        });
    }
  };

  return (
    <>
      <section
        className="home-contact"
        style={{ zIndex: "9", position: "relative" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-5  col-sm-12 animate__animated animate__backInLeft">
              <div className="img-cont lecture_Img">
                <img
                  src={HomeContact}
                  alt=""
                  className="image-fluid home-contact-image"
                />
              </div>
            </div>
            <div className="col-lg-7  col-sm-12 animate__animated animate__backInRight">
              <div className="head_title_contact">
                <h2 className="shadow-title shadow-title2">Book Now</h2>
                <h2 className="main-Title">{farmerMembership?.heading} </h2>
                <p className="main-para">{farmerMembership?.description}</p>

                <div className="home-all-input">
                  <div className="container">
                    {loading ? (
                      <Skeleton count={5} />
                    ) : (
                      <div>
                        <h3 className="priceRate ">
                          <span className="ml-2">
                            ${" "}
                            {state?.other_memberships_included
                              ? `${
                                  parseInt(singleCamping?.price) +
                                  parseInt(farmerMembership?.price)
                                }`
                              : farmerMembership?.price}
                          </span>
                        </h3>

                        <div className="formContainer">
                          {/* <p className="sub-title">Booking Details</p> */}
                          <div className="row">
                            <div className="col-lg-6 mt-4">
                              <p className="sub-title-sm">Select the Date</p>
                              <input
                                min={new_date}
                                onKeyDown={(e) => e.preventDefault()}
                                // onkeydown="return false"
                                value={state.booking_date}
                                name="booking_date"
                                onChange={setFarmMemberFunc}
                                type="date"
                              />
                            </div>
                            <div className="col-lg-6 mt-4">
                              <p className="sub-title-sm">
                                Select Check-in Time
                              </p>
                              <input
                                value={state.booking_time}
                                name="booking_time"
                                onChange={setFarmMemberFunc}
                                type="time"
                              />
                            </div>

                            <div className="col-lg-6 mt-4">
                              <p className="sub-title-sm">
                                Select location on farm
                              </p>
                              <select
                                onChange={(e) => {
                                  setLocatinVal(e.target.value);
                                }}
                              >
                                {locationMemb?.map((item, index) => {
                                  return (
                                    <option key={index + 8561} value={item.id}>
                                      {item.name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          {Token ? (
                            <>
                              <p className="sub-title mt-4">Payment Details </p>
                              <StripeForm
                                // styling={styling}
                                paynow="SUBMIT"
                                PaymentHandler={PlaceOrderHandler}
                                loading={loading}
                              />
                            </>
                          ) : (
                            <>
                              <p className="sub-title mt-4">Payment Details </p>
                              <div className="camping_btn">
                                <button
                                  onClick={() => {
                                    navigate("/login");
                                  }}
                                  className="btn"
                                >
                                  Sign In
                                  <img
                                    src={arrow}
                                    className="image-fluid pl-2"
                                  />
                                </button>
                                <button
                                  onClick={() => {
                                    navigate("/signup");
                                  }}
                                  className="btn secondbtn"
                                >
                                  Create An Account
                                  <img
                                    src={arrow}
                                    className="image-fluid pl-2"
                                  />
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HomeContactForm;
